import { render, staticRenderFns } from "./FirmwareDownload.vue?vue&type=template&id=dfb4196e"
import script from "./FirmwareDownload.vue?vue&type=script&lang=js"
export * from "./FirmwareDownload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports